import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import BanDoNongHoaApi from '../../api/BanDoNongHoaApi';
import ThongBao from '../../core/ThongBao';
import { Loading } from '../loading/Loading';
import { SelectHuyen } from '../selecthuyen/SelectHuyen';
import { SelectXa } from '../selectxa/SelectXa';


export const ModalNongHoa = (props) => {
    const [show, setShow] = useState(false);
    const { register, handleSubmit, reset } = useForm();
    const [huyen, setHuyen] = useState({});
    const [xa, setXa] = useState({});
    const [listphKCLs, setListphKCL] = useState([]);
    const [selectedphKCL, setSelectedphKCL] = useState();
    const [listtsDams, setListtsDam] = useState([]);
    const [selectedtsDam, setSelectedtsDam] = useState();
    const [listtsLan, setListtsLan] = useState([]);
    const [selectedtsLan, setSelectedtsLan] = useState();
    const [listtsKalis, setListtsKali] = useState([]);
    const [selectedtsKali, setSelectedtsKali] = useState();
    const [listdtLans, setListdtLan] = useState([]);
    const [selecteddtLan, setSelecteddtLan] = useState();
    const [listdtKalis, setListdtKali] = useState([]);
    const [selecteddtKali, setSelecteddtKali] = useState();
    const [listCecs, setListCec] = useState([]);
    const [selectedCec, setSelectedCec] = useState();
    const [listOcs, setListOc] = useState([]);
    const [selectedOc, setSelectedOc] = useState();
    const [listTpcgs, setListTpcg] = useState([]);
    const [selectedTpcg, setSelectedTpcg] = useState();
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        props.handleClose();
        setShow(false);
    };

    useEffect(() => {

        if (props.showModal === true) {
            setShow(true);
            reset({
                id: props.thongTin.id,
                maXa: props.thongTin.maXa,
                tenXa: props.thongTin.tenXa,
                maHuyen: props.thongTin.maHuyen,
                tenHuyen: props.thongTin.tenHuyen,
                maTinh: props.thongTin.maTinh,
                tenTinh: props.thongTin.tenTinh,
                DienTich: props.thongTin.DienTich,
                phKCl: props.thongTin.phKCl,
                tsDam: props.thongTin.tsDam,
                tsLan: props.thongTin.tsLan,
                tsKali: props.thongTin.tsKali,
                dtLan: props.thongTin.dtLan,
                dtKaLi: props.thongTin.dtKaLi,
                CEC: props.thongTin.CEC,
                OC: props.thongTin.OC,
                maTPCG: props.thongTin.maTPCG,
                maNongHoa: props.thongTin.maNongHoa,
                Ghichu: props.thongTin.Ghichu,
                tenDatTCVN: props.thongTin.tenDatTCVN
            }, [reset]);
            BanDoNongHoaApi.getAllDanhMuc().then((res) => {
                setListphKCL(res[0].rows);
                setListtsDam(res[1].rows);
                setListtsLan(res[2].rows);
                setListtsKali(res[3].rows);
                setListdtLan(res[4].rows);
                setListdtKali(res[5].rows);
                setListCec(res[6].rows);
                setListOc(res[7].rows);
                setListTpcg(res[8].rows);
                let index = res[0].rows.findIndex(x => x.value === props.thongTin?.phKCl);
                if (index !== -1) {
                    setSelectedphKCL(res[0].rows[index]);
                }
                index = res[1].rows.findIndex(x => x.value === props.thongTin?.tsDam);
                if (index !== -1) {
                    setSelectedtsDam(res[1].rows[index]);
                }
                index = res[2].rows.findIndex(x => x.value === props.thongTin?.tsLan);
                if (index !== -1) {
                    setSelectedtsLan(res[2].rows[index]);
                }
                index = res[3].rows.findIndex(x => x.value === props.thongTin?.tsKali);
                if (index !== -1) {
                    setSelectedtsKali(res[3].rows[index]);
                }
                index = res[4].rows.findIndex(x => x.value === props.thongTin?.dtLan);
                if (index !== -1) {
                    setSelecteddtLan(res[4].rows[index]);
                }
                index = res[5].rows.findIndex(x => x.value === props.thongTin?.dtKaLi);
                if (index !== -1) {
                    setSelecteddtKali(res[5].rows[index]);
                }
                index = res[6].rows.findIndex(x => x.value === props.thongTin?.CEC);
                if (index !== -1) {
                    setSelectedCec(res[6].rows[index]);
                }
                index = res[7].rows.findIndex(x => x.value === props.thongTin?.OC);
                if (index !== -1) {
                    setSelectedOc(res[7].rows[index]);
                }
                index = res[8].rows.findIndex(x => x.value === props.thongTin?.maTPCG);
                if (index !== -1) {
                    setSelectedTpcg(res[8].rows[index]);
                }
            })
        }
    }, [props.showModal]);

    const onChangeHuyen = (e) => {
        setHuyen(e);
    }

    const onChangeXa = (e) => {
        setXa(e);
    }


    const onSubmit = (data) => {

        try {
            data.maHuyen = huyen?.ma;
            data.tenHuyen = huyen?.label;
            data.maXa = xa?.value;
            data.tenXa = xa?.label;
            data.geoText = props.thongTin?.geoText;
            data.id = props.thongTin.id;
            data.phKCL = selectedphKCL?.value;
            data.tsDam = selectedtsDam?.value;
            data.tsLan = selectedtsLan?.value;
            data.tsKali = selectedtsKali?.value;
            data.dtLan = selecteddtLan?.value;
            data.dtKali = selecteddtKali?.value;
            data.CEC = selectedCec?.value;
            data.OC = selectedOc?.value;
            data.maTPCG = selectedTpcg?.value;
            
            setLoading(true);
            if (data.id != null) {
                BanDoNongHoaApi.update(data).then((res) => {
                    ThongBao.printSuccessMessage('Cập nhật thành công!');
                    handleClose();
                    props.changeMapComplete();
                    setLoading(false);
                }, (err) => {
                    setLoading(false);
                    ThongBao.printErrorMessage(err);
                });
            }
            else {
                BanDoNongHoaApi.add(data).then((res) => {
                    ThongBao.printSuccessMessage('Cập nhật thành công!');
                    handleClose();
                    props.changeMapComplete();
                    setLoading(false);
                }, (err) => {
                    setLoading(false);
                    ThongBao.printErrorMessage(err);
                });
            }
        }
        catch (ex) {
        }

    }

    return (
        <Modal size='lg' dialogclassName="modalTK" show={show} onHide={handleClose} backdrop="static" keyboard={false} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Thông tin nông hóa</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="user">
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Huyện</label>
                        <div className="col-sm-10">
                            <SelectHuyen maHuyen={props.thongTin.maHuyen} onChangeHuyenProps={(e) => onChangeHuyen(e)}></SelectHuyen>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Xã</label>
                        <div className="col-sm-10">
                            <SelectXa maXa={props.thongTin.maXa} maHuyen={huyen.ma} onChangeXaProps={(e) => onChangeXa(e)}></SelectXa>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Mã nông hóa</label>
                        <div className="col-sm-4">
                            <input name="maNongHoa" type="text" className="form-control" placeholder="Mã nông hóa" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">pHKCL</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="pHKCL"
                                placeholder="Chọn pHKCL"
                                value={selectedphKCL}
                                onChange={(e) => { setSelectedphKCL(e) }}
                                options={listphKCLs}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">Diện tích</label>
                        <div className="col-sm-4">
                            <input name="DienTich" type="text" className="form-control" placeholder="Diện tích" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">tsDam</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="tsDam"
                                placeholder="Chọn tsDam"
                                value={selectedtsDam}
                                onChange={(e) => { setSelectedtsDam(e) }}
                                options={listtsDams}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">tsLan</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="tsLan"
                                placeholder="Chọn tsLan"
                                value={selectedtsLan}
                                onChange={(e) => { setSelectedtsLan(e) }}
                                options={listtsLan}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">tsKali</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="tsKali"
                                placeholder="Chọn chế độ tiêu"
                                value={selectedtsKali}
                                onChange={(e) => { setSelectedtsKali(e) }}
                                options={listtsKalis}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">dtLan</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="dtLan"
                                placeholder="Chọn dtLan"
                                value={selecteddtLan}
                                onChange={(e) => { setSelecteddtLan(e) }}
                                options={listdtLans}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">dtKali</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="dtKali"
                                placeholder="Chọn dtKali"
                                value={selecteddtKali}
                                onChange={(e) => { setSelecteddtKali(e) }}
                                options={listdtKalis}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">CEC</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="cEC"
                                placeholder="Chọn CEC"
                                value={selectedCec}
                                onChange={(e) => { setSelectedCec(e) }}
                                options={listCecs}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                        <label className="col-sm-2 col-form-label text-right">OC</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="oC"
                                placeholder="Chọn OC"
                                value={selectedOc}
                                onChange={(e) => { setSelectedOc(e) }}
                                options={listOcs}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-right">TPCG</label>
                        <div className="col-sm-4">
                            <Select
                                className="select"
                                name="tPCG"
                                placeholder="Chọn TPCG"
                                value={selectedTpcg}
                                onChange={(e) => { setSelectedTpcg(e) }}
                                options={listTpcgs}
                                theme={theme => ({
                                    ...theme,
                                    borderRadius: 0,
                                    height: 30,
                                    spacing: {
                                        controlHeight: 30,
                                        menuGutter: 1,
                                        baseUnit: 2,
                                    }
                                })}
                            />
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <div className="form-group row">
                    <a href="#" type="button" className="btn btn-info btn-sm ml-1" onClick={handleSubmit(onSubmit)}><i className='fas fa-save'></i> Lưu</a>
                    <a href="#" type="button" className="btn btn-danger btn-sm ml-1" onClick={handleClose} disabled><i className="fas fa-sign-out-alt"></i> Hủy</a>
                </div>
            </Modal.Footer>
            <Loading loading = {loading}></Loading>
        </Modal>
    );
};